import { render, staticRenderFns } from "./LavorazioneCaricoCarroConvoglio.vue?vue&type=template&id=72c05548&scoped=true"
import script from "./LavorazioneCaricoCarroConvoglio.vue?vue&type=script&lang=js"
export * from "./LavorazioneCaricoCarroConvoglio.vue?vue&type=script&lang=js"
import style0 from "./LavorazioneCaricoCarroConvoglio.vue?vue&type=style&index=0&id=72c05548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c05548",
  null
  
)

export default component.exports